import { Alert, AlertModel, AlgoliaAlert, ObjectType } from '../types/alerts';

const alertModelToObjectType = {
  [AlertModel.AreaAlert]: ObjectType.Area,
  [AlertModel.TrailAlert]: ObjectType.Trail
};

const getObjectType = (alert: Alert): ObjectType => alertModelToObjectType[alert.type];

const getTimestamp = (date: string) => (date ? Math.floor(new Date(date).getTime() / 1000) : null);

const getAlgoliaAlert = (alert: Alert): AlgoliaAlert => ({
  ID: alert.id,
  object_type: getObjectType(alert),
  object_id: alert.objectId,
  name: alert.shortName,
  alert_type: alert.alertType,
  status: alert.status,
  start_date: getTimestamp(alert.startDate),
  end_date: getTimestamp(alert.endDate)
});

// These allow a user to edit a UTC date/time without it being automatically shown as local time by DatePicker
const adjustToSameNominalTimeForUser = (utcDateTimeString: string) => Date.parse(utcDateTimeString) + 60000 * new Date().getTimezoneOffset();
const adjustFromSameNominalTimeForUser = (localDateObject: Date) => new Date(localDateObject.getTime() - 60000 * new Date().getTimezoneOffset());

// eslint-disable-next-line import/prefer-default-export
export { getAlgoliaAlert, adjustToSameNominalTimeForUser, adjustFromSameNominalTimeForUser };
